<template>
  <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions -->
  <div ref="contentRef" @click="onClick">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { isExternalUrl } from '~/helpers/url'
import { toRelativeUrl } from '#vuepal/helpers/url'

const router = useRouter()
const contentRef = ref<HTMLDivElement>()

// Add matomo_download class to file download links in CKEditor content
onMounted(() => {
  if (!contentRef.value) return

  const links = contentRef.value.querySelectorAll('a')
  links.forEach((link) => {
    const href = link.href
    const match = router.resolve(href)

    // Check if it's a media canonical URL or document link
    if (
      (match.name && match.name.toString().startsWith('media-canonical')) ||
      href.includes('/media/') ||
      href.includes('/dokumente/') ||
      href.includes('/documents/') ||
      href.includes('/documenti/')
    ) {
      link.classList.add('matomo_download')
    }
  })
})

function onClick(e: MouseEvent) {
  if (!(e.target instanceof HTMLElement)) {
    return
  }

  const link = e.target.closest('a')
  if (!(link instanceof HTMLAnchorElement)) {
    return
  }

  const href = link.href
  if (isExternalUrl(href)) {
    return
  }

  // Webform.
  if (href.includes('/form/')) {
    return
  }

  // Handle media canonical URLs.
  const match = router.resolve(href)
  if (match.name && match.name.toString().startsWith('media-canonical')) {
    return
  }

  // Internal link that can be Nuxt routed.
  e.preventDefault()
  router.push(toRelativeUrl(href))
}
</script>
